export const GIFT_CARD = 'GIFT_CARD';
export const VOUCHER = 'VOUCHER';
export const MEAL_PLAN = 'Meal plan';
export const GC_PLAN = 'Gift card plan';
export const GC_PLAN_SUBTITLE_STEP_1 = 'Add Customisation';
export const GC_PLAN_SUBTITLE_STEP_2 = 'Add recipients';
export const GC_PLAN_SUBTITLE_STEP_3 = 'Review and pay';
export const DAILY = 'Daily';
export const MONTHLY = 'Monthly';
export const WEEKLY = 'Weekly';
export const DAY = 'day';
export const WEEK = 'week';
export const MONTH = 'month';
export const GC_PLAN_TITLE = 'Send gift card';
